import React from 'react'
import styles from '../../App.module.css'
import {
    getLineAdjustment,
    getMaxAccountsPerBet,
    setLineAdjustment,
    setMaxAccountsPerBet,
} from '../../services/api'
import { PROVIDER_MAPPING } from '../accounts/helpers'
import { CanonicalSports } from './Games'

export const User = () => {
    const [lineAdjustmentAmount, setLineAdjustmentAmount] = React.useState<
        { [key: string]: number }
    >({})

    const [maxAccountsPerBetData, setMaxAccountsPerBetData] = React.useState<
        | {
            [key: string]: number
        }
        | undefined
    >(undefined)

    const [disableButtons, setDisableButtons] = React.useState<boolean>(false)

    React.useEffect(() => {
        const fetchData = async () => {
            const line = await getLineAdjustment()
            setLineAdjustmentAmount(line)
            const maxAccountsPerBet = await getMaxAccountsPerBet()
            setMaxAccountsPerBetData(maxAccountsPerBet)
        }
        fetchData()
    }, [])

    return (
        <div className={styles.main}>
            <div className={styles.title_and_description}>
                <header>User</header>
                <p>- User specific settings</p>
            </div>
            <div className={styles.section}>
                <div className={styles.section_content}>
                    <div className={styles.user_setting}>
                        <p>Line Adjustment</p>
                        <div style={{ display: 'flex' }}>
                            <p>Default</p>
                            <input
                                defaultValue={lineAdjustmentAmount['default']}
                                onChange={(e) => {
                                    if (!Number(e.target.value)) return
                                    setLineAdjustmentAmount(
                                        prev => ({
                                            ...prev,
                                            default: Number(e.target.value)
                                        })
                                    )
                                }}
                                style={{ width: '20%', marginLeft: 'auto' }}
                            />
                        </div>
                        {CanonicalSports.map((sport) => <div key={sport} style={{ display: 'flex' }}>
                            <p>{sport}</p>
                            <input
                                defaultValue={lineAdjustmentAmount[sport.toLowerCase()]}
                                onChange={(e) => {
                                    if (!Number(e.target.value)) return
                                    setLineAdjustmentAmount(
                                        prev => {
                                            const newState = { ...prev };
                                            newState[sport.toLowerCase()] = Number(e.target.value);
                                            return newState
                                        }
                                    )
                                }}
                                style={{ width: '20%', marginLeft: 'auto' }}
                            />
                        </div>)}
                        <button
                            className={styles.flat}
                            disabled={disableButtons}
                            onClick={() => {
                                setDisableButtons(true)
                                setLineAdjustment(lineAdjustmentAmount)
                                setTimeout(() => setDisableButtons(false), 1000)
                            }}
                        >
                            Save
                        </button>
                    </div>
                    <div className={styles.user_setting}>
                        <p>Max Accounts Per Bet</p>
                        {Object.keys(PROVIDER_MAPPING).map((provider) => {
                            return (
                                <div key={provider} style={{ display: 'flex' }}>
                                    <p>{PROVIDER_MAPPING[Number(provider)]}</p>
                                    <input
                                        style={{
                                            width: '20%',
                                            marginLeft: 'auto',
                                        }}
                                        defaultValue={
                                            maxAccountsPerBetData?.[provider]
                                        }
                                        onChange={(e) => {
                                            const newData =
                                                maxAccountsPerBetData
                                            if (!newData) return
                                            if (!Number(e.target.value)) return
                                            newData[provider] = Number(
                                                e.target.value
                                            )
                                        }}
                                    />
                                </div>
                            )
                        })}
                        <button
                            className={styles.flat}
                            disabled={disableButtons}
                            onClick={() => {
                                if (!maxAccountsPerBetData) return
                                setDisableButtons(true)
                                setMaxAccountsPerBet(maxAccountsPerBetData)
                                setTimeout(() => setDisableButtons(false), 1000)
                            }}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
